import React, { useEffect, useState, useContext } from "react";
import Planproyecto from "./Planproyecto";
import ListaOpciones from "./ListaOpciones";
import { L4SEMANAS, LPROY, LINI, diaMes, masDias, HOY, codiguera, clBasic, sizeFiltros } from "./general";
import { AppContext } from "./index";
import filtroIcon from "./img/filtro.png";
import CerrarVentana from "./CerrarVentana"

export default function EstadoProyectos() {
  let { firebase, usrLogged } = useContext(AppContext);

  const [prioridad, setPrioridad] = useState("Todos");
  const [semaforo, setSemaforo] = useState("Todos");
  const [filtros, setFiltros] = useState(false);
  const [proyectos, setProyectos] = useState(firebase.dataProyectos);
  const [aux, setAux] = useState(1); // para usarlo en la key de cada fila

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = "Estado General de Proyectos";
    document.getElementById("htmlTituloPagS").innerHTML = "";
    setProyectos(firebase.proyectos(prioridad, semaforo));
    cargarCanvas();
    //if (usrLogged.isLogged) cargarCanvas(); // truchada para evitar el render...
  }, [prioridad, semaforo, firebase]);

  function cargarCanvas() {
    setAux(aux + 1);
    // inicializar htmlCanvasTit (titulo del grafico de proyectos)
    var c = document.getElementById("htmlCanvasTit");
    var ctx = c.getContext("2d");
    ctx.clearRect(0, 0, 1270, 55);
    //
    ctx.beginPath();
    ctx.strokeStyle = clBasic;
    ctx.lineWidth = 6;
    ctx.moveTo(0, 9);
    ctx.lineTo(0, 22);
    ctx.stroke();
    ctx.lineWidth = 2;
    ctx.moveTo(LINI, 9);
    ctx.lineTo(LINI, 22);
    ctx.stroke();
    ctx.moveTo(L4SEMANAS, 9);
    ctx.lineTo(L4SEMANAS, 22);
    ctx.stroke();
    ctx.moveTo(LPROY, 9);
    ctx.lineTo(LPROY, 22);
    ctx.stroke();
    ctx.lineWidth = 4;
    ctx.moveTo(0, 9);
    ctx.lineTo(LPROY, 9);
    ctx.stroke();

    ctx.font = "18px Arial";
    ctx.fillStyle = clBasic;
    ctx.fillText(diaMes(firebase.inicioMenor(firebase.proyectos(prioridad, semaforo)), 1), 0, 43);
    ctx.fillText("HOY", LINI, 43);
    let f4sem = diaMes(masDias(HOY, 28), 1);
    ctx.fillText(f4sem, L4SEMANAS - ctx.measureText(f4sem).width, 43);
    let ffin = diaMes(firebase.finMayor(firebase.proyectos(prioridad, semaforo)), 1);
    ctx.fillText(ffin, LPROY - ctx.measureText(ffin).width, 43);
  }

  function FiltroProyectos() {
    const Sfiltros = {
      position: "relative",
      background: "white",
      padding: "10px",
      border: "1px solid white",
      borderRadius: "5px",
      fontSize: sizeFiltros,
      boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
      color: clBasic,
    };
    const Sfiltro = {
      display: "flex",
      flexDirection: "row",
      marginTop: "3px",
    };
    const Setiqueta = {
      width: "5vw",
      fontWeight: 500,
      padding: "3px",
    };
    const Sinput = {
      padding: "3px",
      background: "#F2F2F2",
      width: "5vw",
      textAlign: "center",
      cursor: "pointer",
      borderRadius: "5px",

    };

    return (
      <div style={Sfiltros} >
        <CerrarVentana set={setFiltros} />
        <div style={Sfiltro}>
          <div style={Setiqueta}>Prioridad:</div>
          <div id="EPprioridad" style={Sinput}>
            {prioridad}
          </div>
        </div>
        <div style={Sfiltro}>
          <div style={Setiqueta}>Semáforo:</div>
          <div id="EPsemaforo" style={Sinput}>
            {semaforo}
          </div>
        </div>
        <ListaOpciones setFiltro={setPrioridad} lista={codiguera["prioridad"]} elemento="EPprioridad" titulo={"Prioridades"} />
        <ListaOpciones setFiltro={setSemaforo} lista={codiguera["semaforo"]} elemento="EPsemaforo" titulo={"Semáforo"} />
      </div >
    );
  }

  if (usrLogged.isLogged || true)
    return (
      <div>
        <div style={{ position: "absolute", top: "12vh", left: "3.6vw", zIndex: 8 }}>
          {!filtros && (
            <img
              src={filtroIcon}
              alt="?"
              height="15px"
              width="15px"
              style={{ cursor: "pointer", background: "black" }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.1)}
              onClick={(e) => {
                e.currentTarget.style.opacity = 0.1;
                setFiltros(true);
              }}
            ></img>
          )}
          {filtros && <FiltroProyectos />}
        </div>

        <div style={SestadoProyectos}>
          <div style={Sproyectos}>
            {proyectos.map((proy, index) => {
              return (
                <Planproyecto
                  proyecto={proy}
                  i={index}
                  key={100 * aux + index}
                  iniciomenor={firebase.inicioMenor(proyectos)}
                  finmayor={firebase.finMayor(proyectos)}
                />
              );
            })}
          </div>
          <div style={SlineaTiempo}>
            <div style={ScanvasTiempo}>
              <canvas id="htmlCanvasTit" height="55px" width={`${LPROY + 50}px`}></canvas>
            </div>
          </div>
        </div>
      </div>
    );
  else return <div>Debe loguearse, gil!!</div>;
}

const Sproyectos = {
  height: "76vh",
  width: "99%",
  overflowY: "auto",
};

const SestadoProyectos = {
  position: "relative",
  marginLeft: "20px",
  marginTop: "20px"
};

const SlineaTiempo = {
  display: "flex",
  flexDirection: "row",
  height: "14vh",
  overflow: "hidden",
};

const ScanvasTiempo = {
  marginLeft: "326px",
};
